/**
 * @file
 * Behaviors for the Close Button.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Close Button behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.closeButton = {
    attach: function() {
      $('.close-button')
        .parent()
        .css('position', 'relative')
        .on('click', '.close-button', function() {
          $(this)
            .parent()
            .remove();
        });
    }
  };
})(Drupal, jQuery);
